import { anyOf, is, maybe, objectOf } from "@altostra/type-validations";
import { string } from "@altostra/type-validations/lib/primitives";

export const isPostIntegrationsDirectCdiSourcesSourceIdRefreshSchemasResult = anyOf(
  objectOf({
    status: is("success"),
  }),
  objectOf({
    status: is("error"),
    error: maybe(string),
  })
);
